import type {ClaveDeInforme} from '@cnc/contracts';
import {useState} from 'react';
import {rutaDeInformeGenerado, useDescargaFiltrada} from '../api/documentos';
import {tr} from '../i18n/idioma';
import {numero} from '../utilidades/formato';

// Descarga lo que se ve con los filtros puestos en el formato del archivo base
// (Consolidated Shipments o Status Concentrates Shipments), para compartirlo
// con otros colaboradores (Daniel, 7/10/2026). Queda en Análisis → Informes.
// Con `claseDelBoton` se muestra como opcion de una lista (Herramientas).
export function DescargaEnFormatoBase({
  informe,
  cadena,
  claseDelBoton,
}: {
  informe: ClaveDeInforme;
  cadena: string;
  claseDelBoton?: string;
}) {
  const descarga = useDescargaFiltrada(informe);
  const [aviso, setAviso] = useState<string | null>(null);
  const nombre =
    informe === 'consolidated'
      ? tr('Consolidated Shipments', 'Consolidated Shipments')
      : tr('Status Concentrates Shipments', 'Status Concentrates Shipments');

  const descargar = () => {
    setAviso(null);
    descarga.mutate(cadena, {
      onSuccess: ejecucion => {
        const enlace = document.createElement('a');
        enlace.href = rutaDeInformeGenerado(ejecucion.id);
        enlace.download = ejecucion.nombreArchivo;
        document.body.appendChild(enlace);
        enlace.click();
        enlace.remove();
        setAviso(
          informe === 'consolidated'
            ? tr(`${numero(ejecucion.filas)} Big Bags descargados.`, `${numero(ejecucion.filas)} Big Bags downloaded.`)
            : tr(
                `${numero(ejecucion.filas)} exportaciones descargadas.`,
                `${numero(ejecucion.filas)} exports downloaded.`,
              ),
        );
      },
      onError: error => setAviso(error.message),
    });
  };

  return (
    <span className={claseDelBoton ? 'flex flex-col' : 'inline-flex items-center gap-2'}>
      <button
        type="button"
        onClick={descargar}
        disabled={descarga.isPending}
        title={tr(
          `Descarga lo que se ve con los filtros puestos en el formato del ${nombre}, para compartir.`,
          `Downloads what is shown with the current filters in the ${nombre} format, to share.`,
        )}
        className={
          claseDelBoton ??
          'rounded-md border border-linea bg-white px-3 py-1.5 text-sm hover:bg-papel disabled:opacity-50'
        }
      >
        {descarga.isPending ? tr('Preparando…', 'Preparing…') : `⬇ ${nombre}`}
      </button>
      {aviso && (
        <span
          role="status"
          className={`text-xs ${claseDelBoton ? 'px-3 pb-1' : ''} ${descarga.isError ? 'text-alerta' : 'text-apagado'}`}
        >
          {aviso}
        </span>
      )}
    </span>
  );
}
